import * as pbi from 'powerbi-client';
import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { NgxPowerBiService } from 'ngx-powerbi';
import { Page, IEmbedConfiguration } from 'powerbi-client';
import { Observable, Subscription } from 'rxjs';
import { ReportService } from '../shared/report.service';
import { StateService } from '../../core/state-manager/appstateservice';
import { Report } from '../shared/models/ReportModel';
import { Router, ActivatedRoute } from '@angular/router';
import { AppInsightService } from 'src/app/common/logging/appinsight.service';
import { GoogleAnalyticsService } from './../../core/services/google/google-analytics.service';
import { environment } from 'src/environments/environment';
import { Roles } from 'src/app/core/roles/role-settings.model';
import { compareItems } from 'src/app/common/models/utility';
import { SiteServices } from 'src/app/jj/services/site.services';
import { ReportInstruction } from '../shared/models/ReportInstruction.model';
import { Guid } from 'guid-typescript';
import { SiteModel } from 'src/app/jj/models/site.model';
@Component({
    selector: 'aecf-report',
    templateUrl: './reportobj.component.html',
    styleUrls: ['./reportobj.component.scss']
})

export class ReportComponent implements OnInit, OnDestroy {
    public screenHeight: number;
    private powerBiService: NgxPowerBiService;
    config: IEmbedConfiguration;
    private pbiContainerElement: HTMLElement;
    isLoggedIn$: Observable<boolean>;
    report: Report;
    reportmodel: any;
    pages: pbi.Page[];
    currentPage: pbi.Page;
    tilesClicked: boolean;
    dashboardLoadError: boolean;
    showDashboard = false;
    loggedinSubscription: Subscription;
    isOptionEnabled = true;
    resizeButtonName: any;
    userDetail: any
    showDialog: boolean;
    reportobj: pbi.Report;
    isJJDataGroup: boolean;
    isFTLAGroup: boolean;
    isGrantsPortal: boolean;
    viewAsAdmin = false;
    currentUserRole: Array<Roles>;
    siteList: any;
    activePage: pbi.Page;
    pageSlicers: pbi.VisualDescriptor[];
    reportInstruction: string;
    isEditMode: boolean;
    currentReportTab: string;
    currentUser: any;
    selectedSiteId: number = -1;

    // Page tracking for duration and previous page
    private currentPageName: string = null;
    private currentPageStartTime: number = null;

    // Throttling state for high-volume events
    private readonly DATA_SELECTION_SAMPLE_RATE = 0.2; // 20% sampling

    // Tracks the currently selected values for 'Measure Set'[Measure Short Name]
    private selectedMeasureShortNames: string[] | null = null;
    private measureShortNamesInitialized = false;

    constructor(private reportService: ReportService,
        private currentState: StateService,
        private appInsights: AppInsightService,
        private router: Router,
        private route: ActivatedRoute,
        public googleAnalyticsService: GoogleAnalyticsService,
        private siteService: SiteServices,
        private cdr: ChangeDetectorRef) {
        this.isLoggedIn$ = this.currentState.isLoggedIn$;
        this.loggedinSubscription = this.currentState.isLoggedIn$.subscribe(logged => {
            if (logged && this.currentState.isTokenValid) {
                this.appInsights.logPageView('Dashboard', this.router.url);
                if (this.currentState.isViewAsAdmin) {
                    this.userDetail = this.currentState.getViewingUserData();
                } else {
                    this.userDetail = this.currentState.getUserData();
                }
                this.isJJDataGroup = this.currentState.isJJGroup();
                this.isFTLAGroup = this.currentState.isFTLAGroup();
                this.isGrantsPortal = this.currentState.isGrantsGroup();
                this.showDashboard = (this.userDetail && this.userDetail.reports && this.userDetail.reports.length > 0);
            }
        });

        this.viewAsAdmin = this.currentState.isViewAsAdmin();
    }

    get isCaseyTA() { return (this.currentState.getRole()).some(r => r === Roles.CaseyTA) || (this.currentState.getViewUserRole()).some(r => r === Roles.CaseyTA); }
    get isAdmin() { return (this.currentState.getRole()).some(r => r === Roles.Admin); }

    ngAfterContentChecked() {
        this.cdr.detectChanges();
    }

    editReportInstruction() {
        this.isEditMode = true;
    }

    ischeckPermissions(permission: string): boolean {
        return this.currentState.permissionCheck(permission);
    }

    shouldShowSiteDropdown(): boolean {
        // Check if user has ViewAllSites permission
        if (this.ischeckPermissions('ViewAllSites')) {
            return true;
        }

        // Check if user has 2 or more assigned sites
        if (this.currentUser?.sites && this.currentUser.sites.length >= 2) {
            return true;
        }

        // Don't show dropdown for users with 0-1 sites and no ViewAllSites permission
        return false;
    }


    getSites() {
        this.siteService.getSites()
            .subscribe(data => {
                this.siteList = data;

                // User doesn't have ViewAllSites permission
                if (!this.ischeckPermissions('ViewAllSites')) {
                    // Filter to only show assigned sites
                    let currentUserSites = this.currentUser.sites as SiteModel[];
                    let results = currentUserSites.map(s => s.id);
                    this.siteList = this.siteList.filter(s => results.includes(s.id));
                }
                // If user has ViewAllSites permission AND not in "view as" mode, show all sites
                this.siteList.sort((nodeA, nodeB) => compareItems(nodeA['name'], nodeB['name']));
            });
    }

    getReportInstructions(reportId: Guid, reportTab: string) {
        this.reportService.getReportInstructions(reportId, reportTab).subscribe(data => {
            this.reportInstruction = data.instructions;

        });
    }

    saveReportInstructions() {
        let rptInstruction = new ReportInstruction();
        rptInstruction.instructions = this.reportInstruction;
        rptInstruction.reportTab = this.currentReportTab;
        rptInstruction.reportId = this.reportmodel.id;
        this.reportService.AddUpdateReportInstructions(rptInstruction).subscribe(x => {
            this.isEditMode = false;
        });
    }

    cancelReportInstructions() {
        this.isEditMode = false;
    }

    ngOnInit() {
        if (this.viewAsAdmin) {
            this.currentUserRole = this.currentState.getViewUserRole();
            this.currentUser = this.currentState.getViewingUserData();
        } else {
            this.currentUserRole = this.currentState.getRole();
            this.currentUser = this.currentState.getUserData();
        }
        this.screenHeight = (window.screen.height);
        this.route.params.subscribe(params => {
            let reportName = params['reportName'];
            localStorage.setItem('reportName', reportName);
            this.bindReportObject(reportName);
            this.currentState.isReportOpened.next(true);
            this.resizeButtonName = "OFF";
            this.getSites();
        });


    }

    async onSiteSelected(value: any) {
        this.activePage = await this.reportobj.getActivePage();
        let reportName = localStorage.getItem('reportName');
        this.selectedSiteId = value;
        if (value == -1) {
            this.bindReportObject(reportName);
            return;
        }
        else if (value == 0) {
            this.bindReportObject(reportName, 0);
        }
        else {
            let selectedSite = this.siteList.filter(x => x.name === value)[0];
            this.bindReportObject(reportName, selectedSite.id);
        }
    }

    async onOptionsSelected(value: string) {
        // todo : in future implementation - v1.0 API dont have export report with filters
        const pages = await this.reportobj.getPages();
        let filters = [];
        // const page = pages[0];
        // const pageFilters = await page.getFilters();
        // const visuals = await page.getVisuals();
        // let slicers = visuals.filter(function (visual) {
        //     return visual.type === "slicer";
        // });

        // for (let sindex = 0; sindex < slicers.length; sindex++) {
        //     const slicer = slicers[sindex];
        //     const state = await slicer.getSlicerState();
        //     filters.push(JSON.stringify(state.filters));
        // }

        this.route.params.subscribe(params => {
            const reportName = params['reportName'];
            const fileContentType = value === 'PDF' ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
            if (value === 'PDF' || value === 'PPTX') {
                this.isOptionEnabled = false;
                let exportReportParameters = { reportName: reportName, format: value, filters: filters };
                this.reportService.exportReport(exportReportParameters).subscribe(res => {
                    this.showDialog = true;
                }, error => { this.isOptionEnabled = true; });
                this.googleAnalyticsService
                    .eventEmitter('Export Report', reportName, 'Report');
            }
        });
    }

    cancelDialog(): void {
        this.showDialog = false;
    }

    ngOnDestroy() {
        // Log how long user spent on this report before leaving
        if (this.currentPageStartTime !== null && this.reportmodel) {
            const now = Date.now();
            const totalDurationSeconds = Math.round((now - this.currentPageStartTime) / 1000);



            this.appInsights.logEvent('PowerBI_ReportExited', {...this.getBaseTelemetryProperties(),
                lastPageViewed: this.currentPageName,
                totalDurationSeconds: totalDurationSeconds,
                exitReason: 'navigation'
            });
        }

        if (this.loggedinSubscription) {
            this.loggedinSubscription.unsubscribe();
        }
        this.currentState.isReportOpened.next(false);
    }

    onToggleScreen(): void {
        if (this.currentState.showheaderAndFooter) {
            this.currentState.isReportOpened.next(false);
            this.resizeButtonName = "ON";
        }
        else {
            this.currentState.isReportOpened.next(true);
            this.resizeButtonName = "OFF";
        }
    }
    gotoDownloads(): void {
        this.router.navigateByUrl('exportReports');
    }

    /**
     * After a HierarchySlicer1458836712039 click, reads filters applied to 'Measure Set'[Measure Short Name]
     * from a non-slicer visual on the active page. When the value differs from the stored state,
     * updates the state and logs a change event to App Insights.
     */
    /**
     * Reads the current filter values for 'Measure Set'[Measure Short Name] from a
     * cross-filterable visual on the active page.
     * Returns the new values array if the selection has changed since last check,
     * or null if unchanged or an error occurred.
     */
    private async checkMeasureShortNameChange(): Promise<string[] | null> {
        try {
            // Wait briefly for the SDK to propagate the slicer selection
            await new Promise(r => setTimeout(r, 300));

            const activePage = await this.reportobj.getActivePage();
            const visuals = await activePage.getVisuals();

            // Read directly from the hierarchy slicer — getFilters() on other visuals
            // does NOT reflect cross-filter state; getSlicerState() on the slicer itself does.
            const slicerVisual = visuals.find(v => v.type === 'HierarchySlicer1458836712039');
            if (!slicerVisual) return null;

            const slicerState = await slicerVisual.getSlicerState();

            // Find the filter targeting 'Measure Set'[Measure Short Name]
            // Hierarchy slicers produce tuple filters where target is an array and
            // values are arrays of { value } objects (one per target column).
            const measureFilter = (slicerState.filters ?? []).find(
                (f: any) => {
                    const targets = Array.isArray(f.target) ? f.target : [f.target];
                    return targets.some(
                        (t: any) => t?.table === 'Measure Set' && t?.column === 'Measure Short Name'
                    );
                }
            ) as any;

            let newValues: string[] = [];
            if (measureFilter) {
                const targets = Array.isArray(measureFilter.target) ? measureFilter.target : [measureFilter.target];
                const colIndex = targets.findIndex(
                    (t: any) => t?.table === 'Measure Set' && t?.column === 'Measure Short Name'
                );
                if (colIndex >= 0 && Array.isArray(measureFilter.values)) {
                    // Tuple filter: each entry in values is an array of { value } objects
                    newValues = measureFilter.values
                        .map((tuple: any) => {
                            if (Array.isArray(tuple)) {
                                return String(tuple[colIndex]?.value ?? '');
                            }
                            // Basic filter fallback: values are plain scalars
                            return String(tuple ?? '');
                        })
                        .filter((v: string) => v !== '');
                }
            }

            // Compare with stored state (serialize both for reliable array equality)
            if (JSON.stringify(newValues) !== JSON.stringify(this.selectedMeasureShortNames ?? [])) {
                this.selectedMeasureShortNames = newValues;
                return newValues;
            }
            return null;
        } catch (err) {
            console.error('Error checking Measure Short Name filter:', err);
            return null;
        }
    }

    private getBaseTelemetryProperties(): any {
        const userInfo = { user: this.currentUser?.userPrincipalName, id: this.currentUser?.id };
        const reportInfo = { reportName: this.reportmodel?.name, reportId: this.config.id };
        const currentPage = this.currentPageName;
        return {
            appRole: 'powerbi-embedded',
            report: reportInfo,
            // Removed: reportId, workspaceId, full userId to minimize PII exposure
            user: userInfo,
            currentPage: currentPage,
            siteSelected: this.selectedSiteId
        };
    }

    getGAIdentifier() {
        if (this.currentState.isKmsGroup()) {
            return 'kms-' + environment.server.toLowerCase();
        } else if (this.currentState.isReportingGroup()) {
            return 'reporting-' + environment.server.toLowerCase();
        } else if (this.currentState.isAllGroup()) {
            return 'all-' + environment.server.toLowerCase();
        } else if (this.currentState.isJDAIGroup()) {
            return 'jdai-' + environment.server.toLowerCase();
        } else if (this.currentState.isThriveGroup()) {
            return 'vision-' + environment.server.toLowerCase();
        } else if (this.currentState.isFTLAGroup()) {
            return 'ftla-' + environment.server.toLowerCase();
        } else if (this.currentState.isJCYOIGroup()) {
            return 'jcyoi-' + environment.server.toLowerCase();
        }
        return '';
    }
    reportReset() {
        let bookmark = '';
        this.reportobj.bookmarksManager.getBookmarks().then(bookmarks => {
            bookmarks.forEach(b => {
                bookmark = b.name;
            });
            this.reportobj.bookmarksManager.apply(bookmark);
        }).catch(err => {
            console.log("Error while getBookmarks Error:" + err);
        });
    }

    bindReportObject(reportName: string = '', siteSelected: number = -1) {
        // Reset slicer baseline so the new embed's rendered event re-seeds it
        this.selectedMeasureShortNames = null;
        this.measureShortNamesInitialized = false;

        this.googleAnalyticsService
            .eventEmitter('Render', reportName, 'Report');

        this.reportService.getReportObject(reportName, siteSelected).subscribe(res => {

            this.reportmodel = res;
            let navigation = false;
            if (res.reportType === 'report') {
                if (res.name === 'GMS_Executive_Report' || res.name === 'Finance_Travel_Report') {
                    navigation = true;
                } else {
                    navigation = true;
                }
            }

            if (reportName === 'Portal Analytics') {
                res.embedUrl = res.embedUrl + '&filter=GAID-Details/EnvironmentName eq %27' + environment.server + '%27';
            }
            this.config = {
                type: res.reportType,
                id: res.id,
                accessToken: res.embedToken.token,
                embedUrl: res.embedUrl,
                permissions: pbi.models.Permissions.All,
                tokenType: pbi.models.TokenType.Embed,
                viewMode: pbi.models.ViewMode.View,
                pageName: this.activePage?.name,
                settings: {
                    filterPaneEnabled: false,
                    navContentPaneEnabled: (this.isJJDataGroup || this.isFTLAGroup) ? false : true,
                    layoutType: pbi.models.LayoutType.Custom,
                    customLayout: {
                        displayOption: (this.isJJDataGroup) ? pbi.models.DisplayOption.FitToWidth : pbi.models.DisplayOption.FitToPage
                    },
                    bars: {
                        actionBar: {
                            visible: false
                        }
                    }
                }
            };
            this.pbiContainerElement = document.getElementById('pbi-container');
            this.powerBiService = new NgxPowerBiService();
            this.powerBiService.reset(this.pbiContainerElement);
            this.reportobj = this.powerBiService.embed(this.pbiContainerElement, this.config) as pbi.Report;

            // Remove existing handlers to prevent duplicates
            this.reportobj.off('loaded');
            this.reportobj.off('rendered');
            this.reportobj.off('pageChanged');
            this.reportobj.off('dataSelected');
            this.reportobj.off('visualClicked');
            this.reportobj.off('bookmarkApplied');
            this.reportobj.off('buttonClicked');
            this.reportobj.off('error');

            this.reportobj.on('loaded', async () => {
                try {
                    const [activePage, pages] = await Promise.all([
                        this.reportobj.getActivePage(),
                        this.reportobj.getPages()
                    ]);

                    this.currentPage = pages.find(p => p.name === activePage.name) || activePage;
                    this.currentPageName = this.currentPage?.displayName || 'Unknown';

                    // Preserve the previously active tab when available.
                    if (this.activePage?.name && this.activePage.name !== activePage.name) {
                        await this.reportobj.setPage(this.activePage.name);
                        this.currentPageName = this.activePage?.displayName || this.currentPageName;
                    }
                } catch (err) {
                    console.error('Error during report loaded page initialization:', err);
                }

                this.appInsights.logEvent('PowerBI_ReportLoaded', this.getBaseTelemetryProperties());

                let iframe = this.pbiContainerElement.getElementsByTagName('iframe')[0];
                iframe.setAttribute("frameborder","0");
                iframe.setAttribute("padding-bottom","3%");
                if(this.isJJDataGroup){
                    this.getReportInstructions(res.id,this.currentReportTab);
                }
            }),
                this.reportobj.on('rendered', () => {
                    this.appInsights.logEvent('PowerBI_ReportRendered', this.getBaseTelemetryProperties());

                    // Seed the baseline Measure Short Name selection so that the first
                    // visualClicked comparison has something meaningful to diff against.
                    if (!this.measureShortNamesInitialized) {
                        this.measureShortNamesInitialized = true;
                        this.checkMeasureShortNameChange(); // fire-and-forget; result intentionally ignored
                    }
                });

            this.reportobj.on('pageChanged', (event: any) => {
                const page = event.detail.newPage;
                const pageDisplayName = page.displayName; // Human-readable: "Overview", "Demographics"
                const now = Date.now();

                // Calculate duration on previous page
                let durationSeconds = null;
                let previousPage = this.currentPageName;

                if (this.currentPageStartTime !== null) {
                    durationSeconds = Math.round((now - this.currentPageStartTime) / 1000);
                }

                // Update tracking variables - use displayName (no IDs)
                this.currentPageName = pageDisplayName;
                this.currentPageStartTime = now;



                this.appInsights.logEvent('PowerBI_PageChanged', {
                    ...this.getBaseTelemetryProperties(),
                    previousPage: previousPage,
                    durationSeconds: durationSeconds
                });
            });

            this.reportobj.on('buttonClicked', (event: any) => {
                this.appInsights.logEvent('PowerBI_ButtonClicked', {
                    ...this.getBaseTelemetryProperties(),
                    buttonId: event.detail.id,
                    buttonTitle: event.detail.title
                });

            });

            this.reportobj.on('dataSelected', (event: any) => {
                const visual = event.detail?.visual;
                const filters = event.detail?.filters;
                const dataPoints = event.detail?.dataPoints;

                this.appInsights.logEvent('PowerBI_DataSelected', {
                    ...this.getBaseTelemetryProperties(),
                    visual: visual?.name,
                    filters: filters,
                    dataPoints: dataPoints
                });
            });
            this.reportobj.on('visualClicked', (event: any) => {
                const visual = event.detail?.visual;

                // When a hierarchy slicer is clicked, check whether the
                // 'Measure Set'[Measure Short Name] selection has changed
                if (visual?.type === 'HierarchySlicer1458836712039') {
                    this.checkMeasureShortNameChange().then(newValues => {
                        if (newValues !== null) {
                            const dataPoints = newValues.map(val => ({
                                identity: {
                                    target: {
                                        table: 'Measure Set',
                                        column: 'Measure Short Name'
                                    },
                                    equals: val
                                },
                                values: []
                            }));
                            this.appInsights.logEvent('PowerBI_DataSelected', {
                                ...this.getBaseTelemetryProperties(),
                                visual: visual?.name,
                                filters: null,
                                dataPoints: dataPoints
                            });
                        }
                    });
                }
            });

            this.reportobj.on('bookmarkApplied', (event: any) => {
                const bn = event.detail?.bookmarkName;

                this.appInsights.logEvent('PowerBI_BookmarkApplied', {
                    ...this.getBaseTelemetryProperties(),
                    bookmark: bn
                });
            });

            this.reportobj.on('error', (event: any) => {
                console.error('Power BI error:', event.detail);
                this.appInsights.logException(
                    new Error(event.detail.message || 'Power BI Error'),
                    'PowerBI_Error',
                    {
                        ...this.getBaseTelemetryProperties(),
                        detailedMessage: event.detail.detailedMessage,
                        errorCode: event.detail.errorCode,
                        httpStatusCode: event.detail.httpStatusCode
                    }
                );
            });
        },
            err => {
                console.log('❌❌❌ ERROR in getReportObject subscribe:', err);
                console.log(err);
                this.dashboardLoadError = true;
                throw new Error('Exception occured while rendering the dashboard:' + err);
            });
    }

}

